import classNames from 'classnames/bind';
import styles from './Payment.module.scss';
import TableClassicReport from '../base/TableClassicReport';
import { useEffect, useState } from 'react';
import { IPaginationReport, IPaymentRecord } from '~/utils/interface/report';
import reportApi from '~/apis/report';
import { ColumnType } from '~/utils/types/common';
import dayjs from 'dayjs';

const cx = classNames.bind(styles);

const Payment = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<IPaymentRecord[]>([]);
  const [pagination, setPagination] = useState<IPaginationReport>({
    totalItems: 0,
    totalPage: 0,
    page: 1,
    limit: 10,
    skip: 0,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await reportApi.getPayments({ page: pagination.page });
        setData(response.data?.data?.responses ?? []);
        setPagination(response.data?.data?.pagination ?? {
          totalItems: 0,
          totalPage: 0,
          page: 1,
          limit: 10,
          skip: 0,
        });
        setLoading(false);
      } catch (error) {
        console.error('Failed to fetch payments', error);
        setLoading(false);
      }
    };
    fetchData();
  }, [pagination.page]);

  const columns: Array<ColumnType> = [
    {
      id: "datePayment",
      labelHeader: "Date Payment",
      renderCell: (payment: IPaymentRecord) => (
        <div
          className={cx("cell")}
        >
          <p className={cx("text-content")}>{dayjs(payment.datePayment).format("MM/DD/YYYY") || "-"}</p>
        </div>
      ),
    },
    {
      id: "reference",
      labelHeader: "Reference #",
      renderCell: (payment: IPaymentRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{payment.reference || "-"}</p>
        </div>
      ),
    },
    {
      id: "total",
      labelHeader: "Total",
      renderCell: (payment: IPaymentRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>${payment.total || "0"}</p>
        </div>
      ),
    },
    {
      id: "invoice",
      labelHeader: "Invoice",
      renderCell: (payment: IPaymentRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{payment.invoice ? `$${payment.invoice.total} (${payment.invoice.uniqueCode})` : "-"}</p>
        </div>
      ),
    },
    {
      id: "method",
      labelHeader: "Method",
      renderCell: (payment: IPaymentRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{payment.method || "-"}</p>
        </div>
      ),
    },
    {
      id: "relatedRecord",
      labelHeader: "Related Records",
      renderCell: (payment: IPaymentRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{payment.invoice.uniqueCode ? `${payment.invoice.uniqueCode} (Invoice)` : "-"}</p>
          <p className={cx("text-content")}>{payment.relatedContact.name ? `${payment.relatedContact.name} (Contact)` : "-"}</p>
          <p className={cx("text-content")}>{payment.job.uniqueCode ? `${payment.job.uniqueCode} (Job)` : "-"}</p>
        </div>
      ),
    },
    {
      id: "createdBy",
      labelHeader: "Created By",
      renderCell: (payment: IPaymentRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{payment?.createdByAccount?.name || "-"}</p>
        </div>
      ),
    },
    {
      id: "dateUpdated",
      labelHeader: "Date Updated",
      renderCell: (payment: IPaymentRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{dayjs(payment.dateUpdated).format("MM/DD/YYYY hh:mm A") || "-"}</p>
        </div>
      ),
    },
    {
      id: "status",
      labelHeader: " Status",
      renderCell: (payment: IPaymentRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{payment.status || "-"}</p>
        </div>
      ),
    },
  ];

  return (
    <TableClassicReport
      title="Payments"
      columns={columns}
      data={data}
      page={pagination.page}
      totalPages={pagination.totalPage}
      totalItems={pagination.totalItems}
      itemsPerPage={pagination.limit}
      onPageChange={(page) => {
        setPagination({ ...pagination, page });
      }}
      isLoading={loading}
    />
  );
};

export default Payment;
